import { render, staticRenderFns } from "./simplyLogin.vue?vue&type=template&id=3b0acabf&scoped=true"
import script from "./simplyLogin.vue?vue&type=script&lang=js"
export * from "./simplyLogin.vue?vue&type=script&lang=js"
import style0 from "./simplyLogin.vue?vue&type=style&index=0&id=3b0acabf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0acabf",
  null
  
)

export default component.exports